import * as Icon from "@ant-design/icons";
import { Button, Modal, Form, Row, Col, Flex } from "antd";
import { ColumnsType } from "antd/es/table";
import { useEffect } from "react";
import { ConfiguracaoImportacaoVendaModel } from "../../models/configuracaoImportacaoVenda/configuracaoImportacaoVendaModel";
import { setIdEmpresaPermissao, setTitle } from "../../redux/slices/configuracoes/configuracoesSlice";
import {
  setEntityConfiguracaoImportacaoVenda,
  setModalCadastrarConfiguracaoImportacaoVenda,
  setModalDeletarConfiguracaoImportacaoVenda,
} from "../../redux/slices/configuracaoImportacaoVenda/configuracaoImportacaoVendaSlice";
import {
  setModalCadastrarDetalheConfiguracaoImportacaoVenda,
  setBuscaDetalheConfiguracaoImportacaoVenda,
} from "../../redux/slices/detalheConfiguracaoImportacaoVenda/detalheConfiguracaoImportacaoVendaSlice";
import { deletarConfiguracaoImportacaoVenda, listarConfiguracaoImportacaoVenda } from "../../services/configuracaoImportacaoVendaService";
import { useAppSelector, useAppDispatch } from "../../util/hooks";
import { formatPercent } from "../../util/dinheiroBRAuxiliar";
import { ItemMenuAcoes } from "../../models/sistema/itemMenuAcoes";
import AcoesComponent from "../../components/table/acoesComponent";
import dayjs from "dayjs";
import TableComponent from "../../components/table/tableComponent";
import MensagemModal from "../../components/modal/mensagem";
import CadastroConfiguracaoImportacaoVendaModal from "./modals/cadastrar";
import DetalheConfiguracaoImportacaoVendaModal from "./modals/detalhe";
import { ButtonComponent } from "../../components/button/cadastrar";

dayjs.locale("pt-br");

const ConfiguracaoImportacaoVenda = () => {
  //estados globais
  const configuracaoImportacaoVendaState = useAppSelector((state) => state.configuracaoImportacaoVenda);
  const detalheConfiguracaoImportacaoVendaState = useAppSelector((state) => state.detalheConfiguracaoImportacaoVenda);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais

  const editar = Object.values(configuracaoImportacaoVendaState.entity).length !== 0;

  useEffect(() => {
    dispatch(setTitle("CONFIGURAÇÃO DE IMPORTAÇÃO DE VENDA"));
    dispatch(listarConfiguracaoImportacaoVenda(configuracaoImportacaoVendaState.busca));
  }, []);

  const goCadastrar = () => {
    dispatch(setEntityConfiguracaoImportacaoVenda({}));
    dispatch(setModalCadastrarConfiguracaoImportacaoVenda(true));
  };

  const goEditar = (value: ConfiguracaoImportacaoVendaModel) => {
    dispatch(setEntityConfiguracaoImportacaoVenda(value));
    dispatch(setModalCadastrarConfiguracaoImportacaoVenda(true));
  };

  const goDeletar = (value: ConfiguracaoImportacaoVendaModel) => {
    dispatch(setEntityConfiguracaoImportacaoVenda(value));
    dispatch(setModalDeletarConfiguracaoImportacaoVenda(true));
  };

  const closeModalCadastrar = () => {
    dispatch(setModalCadastrarConfiguracaoImportacaoVenda(false));
  };

  const closeModalDeletar = () => {
    dispatch(setModalDeletarConfiguracaoImportacaoVenda(false));
  };

  const closeModalCadastroDetalhe = () => {
    dispatch(setModalCadastrarDetalheConfiguracaoImportacaoVenda(false));
  };

  const goDetalhe = (value: ConfiguracaoImportacaoVendaModel) => () => {
    dispatch(setBuscaDetalheConfiguracaoImportacaoVenda(value.idEmpresa));
    dispatch(setModalCadastrarDetalheConfiguracaoImportacaoVenda(true));
  };

  const items: ItemMenuAcoes[] = [
    {
      label: "Editar",
      key: "1",
      icon: <Icon.EditOutlined />,
      function: (item: any) => goEditar(item),
    },
    {
      label: "Remover",
      key: "2",
      icon: <Icon.DeleteOutlined />,
      function: (item: any) => goDeletar(item),
    },
  ];

  const columns: ColumnsType<ConfiguracaoImportacaoVendaModel> = [
    {
      title: "EMPRESA",
      dataIndex: "empresa",
    },
    {
      title: "INÍCIO",
      dataIndex: "dataInicio",
      align: "center",
      width: 120,
      render: (_, record) => <>{record.dataInicio && dayjs(record.dataInicio).format("DD/MM/YYYY")}</>,
    },
    {
      title: "VIGÊNCIA",
      dataIndex: "dataVigencia",
      align: "center",
      width: 80,
      render: (_, record) => <>{record.dataVigencia && dayjs(record.dataVigencia).format("DD/MM/YYYY")}</>,
    },
    {
      title: "% VENDA FÍSICA (CAP)",
      dataIndex: "percentualComissaoVendaFisicaCapitalizacao",
      align: "right",
      width: 150,
      render: (_, record) => <>{record.percentualComissaoVendaFisicaCapitalizacao && formatPercent(record.percentualComissaoVendaFisicaCapitalizacao)}</>,
    },
    {
      title: "% VENDA FÍSICA (ENT)",
      dataIndex: "percentualComissaoVendaFisicaEntidade",
      align: "right",
      width: 150,
      render: (_, record) => <>{record.percentualComissaoVendaFisicaEntidade && formatPercent(record.percentualComissaoVendaFisicaEntidade)}</>,
    },
    {
      title: "% VENDA ONLINE (CAP)",
      dataIndex: "percentualComissaoVendaOnlineCapitalizacao",
      align: "right",
      width: 150,

      render: (_, record) => <>{record.percentualComissaoVendaOnlineCapitalizacao && formatPercent(record.percentualComissaoVendaOnlineCapitalizacao)}</>,
    },
    {
      title: "% VENDA ONLINE (ENT)",
      dataIndex: "percentualComissaoVendaOnlineEntidade",
      align: "right",
      width: 150,
      render: (_, record) => <>{record.percentualComissaoVendaOnlineEntidade && formatPercent(record.percentualComissaoVendaOnlineEntidade)}</>,
    },
    {
      title: "HISTÓRICO",
      width: 140,
      align: "center",
      render: (_, record) => (
        <Button size="small" onClick={goDetalhe(record)}>
          Ver histórico
        </Button>
      ),
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      width: 55,
      render: (_, record) => <AcoesComponent record={record} items={items} />,
    },
  ];

  return (
    <Flex vertical>
      <Form layout="vertical">
        <Row gutter={12} align="bottom">
          <Col span={24}>
            <Flex justify="end">
              <ButtonComponent onClick={goCadastrar} />
            </Flex>
          </Col>
        </Row>
      </Form>
      <TableComponent data={configuracaoImportacaoVendaState.list} columns={columns} loading={configuracaoImportacaoVendaState.loading} />
      <Modal
        title={editar ? "EDITAR CONFIGURAÇÃO DE IMPORTAÇÃO DE VENDA" : "NOVA CONFIGURAÇÃO DE IMPORTAÇÃO DE VENDA"}
        centered
        width={950}
        open={configuracaoImportacaoVendaState.modalCadastrar}
        closable={false}
        onCancel={closeModalCadastrar}
        footer={null}
        destroyOnHidden
      >
        <CadastroConfiguracaoImportacaoVendaModal />
      </Modal>
      <Modal title={"REMOVER CONFIGURAÇÃO DE IMPORTAÇÃO"} centered width={350} open={configuracaoImportacaoVendaState.modalDeletar} closable={false} onCancel={closeModalDeletar} footer={null}>
        <MensagemModal
          text=" Deseja remover a configuração?"
          action={deletarConfiguracaoImportacaoVenda({ value: configuracaoImportacaoVendaState.entity.id, busca: configuracaoImportacaoVendaState.busca })}
          close={setModalDeletarConfiguracaoImportacaoVenda(false)}
        />
      </Modal>
      <Modal
        title={"VIGÊNCIAS DA CONFIGURAÇÃO DE IMPORTAÇÃO DE VENDA"}
        centered
        width={950}
        open={detalheConfiguracaoImportacaoVendaState.modalCadastrar}
        closable={false}
        onCancel={closeModalCadastroDetalhe}
        footer={null}
        destroyOnHidden
      >
        <DetalheConfiguracaoImportacaoVendaModal />
      </Modal>
    </Flex>
  );
};

export default ConfiguracaoImportacaoVenda;
